import React from 'react';
import { Arrow } from '../../Icons';
import { PrismicLink } from '../../PrismicLink';
import { PrismicTitleFieldType, PrismicLinkFieldType, SliceContext } from '../types';
import './FeaturedArtists.scss';

export type FeaturedArtistsCTAProps = {
    ctaLabel: PrismicTitleFieldType;
    ctaLink: PrismicLinkFieldType;
    sliceContext: SliceContext;
};

export const FeaturedArtistsCTA = ({
    ctaLabel,
    ctaLink,
    sliceContext,
}: FeaturedArtistsCTAProps) => {
    if (!ctaLink || !ctaLabel || !ctaLabel.raw) {
        return null;
    }

    return (
        <PrismicLink link={ctaLink} className="FeaturedArtists-cta-link" slice={sliceContext}>
            <div className="Grid Grid--alignCenter">
                <p>
                    {/* TODO: Use the Heading component to get the right heading level from Prismic */}
                    <span>{ctaLabel.raw[0].text}</span>
                    <span className="FeaturedArtists-cta-arrow">
                        <Arrow size="small" />
                    </span>
                </p>
            </div>
        </PrismicLink>
    );
};
